export default __webpack_public_path__ + "static/media/intro3.48ff8994.mp4";